import { useContext } from 'react';
import { LeaderBoardDataContext } from '../../Contexts/LeaderBoardDataContext';


export const AppStudioTotalData = () => {
  const { totalConsumerEntries, totalPublishedCount } = useContext(LeaderBoardDataContext);


  return [
    {
      title: "Total Users",
      count: totalConsumerEntries
    },
    {
      title: "Total Components",
      count: totalPublishedCount
    },
    {
      title: "Projects Integrated",
      count: 9
    }
  ];
};
